// @flow
import _ from 'lodash';

import ApiManager from './ApiManager';

// constants
import APIEndpoints from '../constants/APIEndpoints';

import KioskApiErrors from '../utils/apiErrors/KioskApiErrors';

// entities
import ApiError from '../entities/ApiError';
import Restaurant from '../entities/Restaurant';
import KioskSettings from '../entities/restaurant/KioskSettings';

class ApiKiosk {

    //
    // Settings
    //

    /**
    * Put the order settings
    */
    static getSettings(restaurantId: string, success: Function, failure: Function) {
      const endpoint = APIEndpoints.KIOSK_SETTINGS.replace(':restaurantId', restaurantId);

      const requestOptions = {
        endpoint,
        query: {},
        success: (json: Object) => {
          console.log('[GET KIOSK SETTINGS] SUCCESS: ', json);

          const kioskSettings: KioskSettings = new KioskSettings();
          kioskSettings.fromJson(json);

          success(kioskSettings);
        },
        failure: (apiError: ApiError) => {
          console.log('[GET KIOSK SETTINGS] FAILURE: ', apiError);
          apiError.localizedMessage = KioskApiErrors.get(apiError);
          failure(apiError);
        }
      }

      ApiManager.get(requestOptions);
    }

    /**
    * Put the order settings
    */
    static putSettings(
      restaurantId: string,
      kioskSettingsToUpdate: KioskSettings,
      files: Object,
      success: Function,
      failure: Function) {
      const endpoint = APIEndpoints.KIOSK_SETTINGS.replace(':restaurantId', restaurantId);

      const requestOptions = {
        endpoint,
        data: {
          settings: JSON.stringify(kioskSettingsToUpdate),
        },
        files,
        success: (json: Object) => {
          console.log('[PUT KIOSK SETTINGS] SUCCESS: ', json);

          const kioskSettings: KioskSettings = new KioskSettings();
          kioskSettings.fromJson(json);

          success(kioskSettings);
        },
        failure: (apiError: ApiError) => {
          console.log('[PUT KIOSK SETTINGS] FAILURE: ', apiError);
          apiError.localizedMessage = KioskApiErrors.put(apiError);
          failure(apiError);
        }
      }

      ApiManager.putMultipart(requestOptions);
    }

  }

  export default ApiKiosk;
